import type { RecommendLeadEvent } from '@app/api/RecommendChat/types';
import { compareRecommendRevisions } from '@app/components/LeadCard/ui/MessageHistory/lib/compareRecommendRevisions';

// A receipt can remove the lead from an unread-only result, so the event on
// the envelope takes precedence over markers on individual result rows.
export const shouldPlayRecommendUpdateSound = (
  envelope: RecommendLeadEvent | null | undefined,
  rowEvents: Array<RecommendLeadEvent | null | undefined>,
  seenRevisions: Map<string, string>
): boolean => {
  const events = envelope
    ? [envelope]
    : rowEvents.filter((event): event is RecommendLeadEvent => Boolean(event));
  if (!events.length) return true;
  let hasNewIncoming = false;
  for (const event of events) {
    const previous = seenRevisions.get(event.messageId);
    const comparison =
      previous === undefined
        ? 1
        : compareRecommendRevisions(event.revision, previous);
    if (comparison === null || comparison <= 0) continue;
    seenRevisions.set(event.messageId, event.revision);
    if (event.kind === 'incoming' && previous === undefined)
      hasNewIncoming = true;
  }
  return hasNewIncoming;
};
